import { get } from 'lodash';

import { FIELD_VALUE_LABELS } from '@funnels/constants';

export const capitalizeForEnumValue = (value: string = '--', skipMapping?: boolean): string =>
  // Capitalize for Enum value if no mapping value in FIELD_VALUE_LABELS ex:TRUST_BENEFICIAL_OWNER => Trust beneficial owner
  get(
    skipMapping ? {} : FIELD_VALUE_LABELS,
    value,
    (value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()).replace(/_/g, ' ')
  );
